<template>
  <div class="container">
    <!-- 搜索 -->
    <div class="search-box df aic jcsb">
      <div class="df">
        <div class="search-list list1 df aic">
          <el-input v-model="searchForm.search_key" clearable :placeholder="$t('请输入')"
            @keyup.enter.native="handleSearch()" @clear="handleSearch()" class="f1"></el-input>
          <el-button type="text" class="btn fn" @click="handleSearch()">{{
            $t("搜索")
          }}</el-button>
        </div>
        <div class="search-list list2">
          <el-select clearable v-model="searchForm.tt_id" :placeholder="$t('请选择')" @change="handleSearch()">
            <el-option v-for="item in topicList" :key="item.tt_id" :label="item.tt_title" :value="item.tt_id">
            </el-option>
          </el-select>
        </div>
      </div>

      <div>
        <template>
          <el-radio v-model="searchForm.sort_method" :label="0" @change="changeSortMethod(0)">{{ $t("默认") }}</el-radio>
          <el-radio v-model="searchForm.sort_method" :label="10" @change="changeSortMethod(10)">{{ $t("最新") }}</el-radio>
        </template>
      </div>
    </div>

    <!-- 列表 -->
    <div class="related-activity">
      <div class="title df aic jcsb">
        <span>{{ $t("话题活动") }}</span>
      </div>

      <div class="activity-box df fww" v-loading="listLoading">
        <div class="list" v-for="(item, index) in listData" :key="item.ta_id"
          @click="$navigate((item.ta_kind==30?'/challenge/info':'/activity/info'), item.ta_id, true)">
          <div class="imgs">
            <el-image :src="item.ta_thumb">
              <img slot="error" src="@/assets/images/news-default.png" alt="" />
            </el-image>
            <!-- <div slot="error" class="image-slot">
                <img src="@/assets/images/news-default.png" alt="">
              </div> -->
            <!-- <img :src="item.ta_thumb" alt="" /> -->
          </div>
          <div class="text-box">
            <div class="t1s one-text mic-semblod">
              {{ item.ta_title }}
            </div>
            <div class="de1 one-text">{{ item.ta_desc }}</div>
            <div class="address df aic jcsb">
              <div class="l1">
                <div>
                  <span class="iconfont">&#xe61f;</span><span class="t1">{{ item.ta_city_text }}</span>
                </div>
                <div>
                  <span class="iconfont">&#xe602;</span><span class="t1">
                   
                    {{ item.ta_start_time }}

                  </span>
                </div>
              </div>
              <el-button class="btn end" v-if="item.is_sign_up == 10">
                {{ $t("活动已结束") }}
              </el-button>
              <el-button class="btn" v-else-if="item.is_sign_up == 20">
                {{ $t("即将举行") }}
              </el-button>
              <el-button class="btn" v-else-if="item.is_sign_up == 30">
                {{ $t("活动报名中") }}
              </el-button>
              <el-button class="btn" v-else-if="item.is_sign_up == 40">
                {{ $t("活动进行中") }}
              </el-button>
            </div>
          </div>
        </div>

        <div class="no-data pt-86" v-if="listData.length == 0">
          <img src="@/assets/images/empty_data.png" alt="" />
          <p>{{ $t("暂无数据") }}</p>
        </div>
      </div>

      <!-- <div class="pager-box df jcc" v-if="pagination.total > 0">
        <el-pagination :total="pagination.total" :current-page="pagination.page" :page-size="10"
          layout="prev,slot, next" @current-change="handleCurrentChange">
          <template><span class="page-slot">{{ pagination.page }}/{{ pagination.last_page }}</span></template>
        </el-pagination>
      </div> -->


      <div class="pageing-box df aic jcc mt-36">

        <el-button type="text" class="add-btn" @click="handlePages(1)">{{ $t('回首页') }}</el-button>

        <el-pagination :current-page="pagination.page" :page-size="pagination.size" :total="pagination.total"
          layout=" prev, pager, next,slot" @current-change="handleCurrentChange">


          <span class="jump-text">{{ $t('跳转') }}</span>
          <el-input-number :controls="false" v-model="jumpIndex" :min="1" :max="totalPages" @change="handleJump"
            size="small" class="jump-ipt pl-0 pr-0" style="width: 28px; margin-left: 8px;" />

        </el-pagination>
        <el-button type="text" class="add-btn ml-11" @click="handlePages(totalPages)">{{ $t('去尾页') }}</el-button>
      </div>


    </div>
  </div>
</template>

<script>
// 接口
import { getTopicActivityList } from "@api/subject";

export default {
  data() {
    return {
      //文章列表 loading
      listLoading: false,
      // 分页
      jumpIndex: '',
      totalPages: 0, //总页数
      pagination: {
        page: 1,
        total: 9,
        size: 9,
        last_page: 1,
      },
      // 搜索框
      searchForm: {
        search_key: "",
        area_level1: "",
        tt_id: 0,
        sort_method: 0,
      },
      topicList: [],

      listData: [],
    };
  },

  computed: {
    tt_id() {
      return parseInt(this.$route.params.id); // 获取路由参数
    },
  },
  mounted() {

    this.searchForm.tt_id = this.tt_id;
    this.getData();
    let topicListStr = localStorage.getItem("topicList");
    this.topicList = JSON.parse(topicListStr);
  },
  methods: {
    // 初始化数据
    async getData() {
      this.listLoading = true;
      const resList = await getTopicActivityList({
        ...this.searchForm,
        page: this.pagination.page,
      });
      if (resList.status == 200) {
        this.pagination.total = resList.data.act_list.total;
        this.listData = resList.data.act_list.data;
        this.pagination.last_page = resList.data.act_list.last_page;
        this.pagination.size = resList.data.act_list.per_page;

        this.totalPages = resList.data.act_list.last_page; // 计算总页数
      }
      this.listLoading = false;
    },

    // 切换话题分类
    changeSubject(tt_id) {
      this.searchForm.tt_id = tt_id;
      this.pagination.page = 1;

      this.getData();
    },
    // 切换排序方式
    changeSortMethod(val) {
      this.searchForm.sort_method = val;
      this.pagination.page = 1;
      this.getData();
    },

    // 切换页码
    handleCurrentChange(val) {
      this.pagination.page = val;
      this.getData();
    },

    // 跳转
    handleJump() {
      this.pagination.page = this.jumpIndex;
      this.getData();
    },

    handlePages(index) {
      this.pagination.page = index;
      this.getData();
    },

    handleSearch() {
      this.pagination.page = 1;
      this.getData();
    },

    handleLink() {
      this.$navigate("/subject/list");
    },
  },
};
</script>

<style lang="scss" scoped>
.pageing-box {
  ::v-deep() {
    .el-pagination button:disabled {
      background-color: transparent;
    }

    .el-pager li {
      background: transparent;
    }

    .el-pagination .btn-prev,
    .el-pagination .btn-next {
      background-color: transparent;
    }

    .jump-ipt {
      box-sizing: border-box;
      border: 1px solid rgba(0, 0, 0, 0.2);
      border-radius: 8px;
      background: rgb(255, 255, 255);
      width: 28px;
      height: 28px;
    }

    .jump-ipt .el-input__inner {
      padding: 0;
      height: 26px;
      line-height: 26px;
      border: none;
      position: relative;
      top: -2px;
      background-color: transparent;

    }
  }
}

.activity-box {
  margin-top: 29px;


  .list {
    width: calc(33.33% - 10.7px);
    margin-bottom: 16px;
    border-radius: 6px;
    box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.08);
    overflow: hidden;
    margin-right: 16px;
    cursor: pointer;

    &:hover {
      .t1s {
        color: #b7251e;
      }

      ::v-deep() {
        .el-image {
          transform: scale(1.1);
        }
      }
    }

    &:nth-child(3n) {
      margin-right: 0;
    }

    .de1 {
      color: rgb(89, 89, 89);
      font-size: 14px;
      line-height: 22px;
      min-height: 22px;
      margin-top: 8px;
    }

    .t1s {
      color: rgb(25, 25, 25);
      font-size: 18px;
      line-height: 28px;
    }

    .text-box {
      padding: 16px;
      background: #ffffff;

      .address {
        .l1 {
          .iconfont {
            font-size: 12px;
            color: #595959;
          }

          .t1 {
            font-size: 12px;
            color: rgb(89, 89, 89);
            line-height: 18px;
            margin-left: 4px;
          }
        }

        .btn {
          min-width: 96px;
          height: 36px;
          line-height: 36px;
          padding: 0 16px;
          border-radius: 20px;
          text-align: center;
          background: rgb(231, 239, 255);
          color: rgb(24, 114, 253);
          font-size: 12px;

          &.end {
            color: #6d7177;
            background: #fff;
            border: 1px solid #6d7177;
          }
        }
      }
    }

    .imgs {
      width: 100%;
      padding-bottom: 52.6%;
      position: relative;
      overflow: hidden;

      ::v-deep() {
        .el-image {
          position: absolute;
          transition: all 1s;
        }

        ::v-deep .el-image {
          width: 100%;
          height: 100%;
      
        }

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }


    }
  }
}

.container {
  padding-top: 120px;
  padding-left: 80px;
  padding-right: 80px;
  background: #f8f8f8;
  min-height: calc(100vh - 280px);

  .search-tab {
    max-width: 1400px;
    margin: 0 auto;
    padding-top: 40px;
    padding-bottom: 19px;

    .filter-btn {
      font-size: 16px;
      color: #999999;
      line-height: 20px;
      margin-right: 36px;
      position: relative;
      transition: all 0.36s;

      &:hover {
        color: #b7251e;
      }
    }
  }

  .search-box {
    max-width: 1400px;
    margin: 0 auto;
    background: #ffffff;
    border-radius: 6px 6px 6px 6px;
    margin-top: 24px;
    padding: 14px 24px;

    .search-list {
      height: 48px;
      border-radius: 100px;
      border: 1px solid rgba($color: #b7251e, $alpha: 0.2);
      margin-right: 16px;
      transition: border 0.36s;
      overflow: hidden;

      &:hover {
        border: 1px solid rgba($color: #b7251e, $alpha: 1);
      }
    }

    .list5 {
      min-width: 114px;
      margin-right: 0;
      padding: 0 16px;
    }

    .list2,
    .list3,
    .list4 {}

    .list1 {
      width: 480px;
      padding-right: 30px;

      .btn {
        width: auto;
      }
    }

    ::v-deep() {
      .el-input__inner {
        height: 46px;
        border: none;
        background: transparent;
        padding-left: 20px;
        padding-right: 30px;
        color: #757575;

        &::placeholder {
          color: #757575;
        }
      }

      .el-input__suffix {
        right: 14px;
      }

      .el-select {
        width: 100%;
      }

      .el-select>.el-input {
        width: 100%;
      }

      .el-button--text {
        width: 100%;
        height: 52px;
      }
    }
  }

  .related-activity {
    max-width: 1400px;
    margin: 0 auto;
    padding-top: 28px;
    padding-bottom: 125px;

    .title {
      color: rgb(25, 25, 25);
      font-family: "MicrosoftYaHeiSemibold";
      font-size: 23px;
      font-weight: 400;
      line-height: 36px;
    }
  }
}

@media screen and (max-width: 1400px) {
  .container .search-box .list1 {
    width: 360px;
  }
}

@media screen and (max-width: 1280px) {
  .container .search-box .list1 {
    width: 240px;
  }
}
</style>